<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">Link
      </h1>
    </div>
  </div>
  <div class="c-header__gradient"> </div>
</div>
<div class="content">
  <h2 _ngcontent-serverapp-c126="">Customized icon size</h2>
  <div class="content__tools-wrap">
    <label for="size" class="content__row-label">size</label>
    <select [(ngModel)]="size" id="size" placeholder="Size" name="size" class="c-input-group__control">
      <ng-container *ngFor="let size of sizeList">
        <option [value]="size">{{ size }}</option>
      </ng-container>
    </select>
    <label for="color" class="content__row-label">size</label>
    <select [(ngModel)]="color" id="color" placeholder="Color" name="color" class="c-input-group__control">
      <ng-container *ngFor="let color of colorList">
        <option [value]="color">{{ color }}</option>
      </ng-container>
    </select>
  </div>
  <p>Use Case 1 : Active Link with Icon</p>
  <maced-link id="linkId1" [links]="link1" [showNextIconClass]="true" [nextIconClass]="nextIconClass"
    [activeClass]="true" [linkSize]="size" [linkColor]="color">
  </maced-link>
  <br>
  <p>Use Case 2 : Default Link with Icon</p>
  <maced-link id="linkId2" [links]="link2" [showBackIconClass]="true" [backIconClass]="backIconClass" [linkSize]="size" [linkColor]="color">
  </maced-link>
  <br>
  <p>Use Case 3 : Default Link with only text</p>
  <maced-link id="linkId3" [links]="link1" [linkSize]="size" [linkColor]="color">
  </maced-link>
  <br>
  <p>Use Case 4 : Link with Icon only</p>
  <maced-link id="linkId4" [links]="link3" [backIconClass]="backIconClass" [showBackIconClass]="true" [linkSize]="size" [linkColor]="color">
  </maced-link>
  <br>
  <p>Use Case 5 : Disabled Link with Icon </p>
  <maced-link id="linkId5" [linkDisabled]="true" [links]="link2" [backIconClass]="backIconClass" [showBackIconClass]="true"
    [disableClass]="true" [linkSize]="size">
  </maced-link>
  <br>
  <p>Use Case 6 : Link in Hindi</p>
  <maced-link id="linkId6" [links]="link4" [showNextIconClass]="true" [linkSize]="size" [linkColor]="color">
  </maced-link>
  <br>
  <p>Use Case 7 : Link in Spanish</p>
  <maced-link id="linkId7" [links]="link5" [showNextIconClass]="true" [linkSize]="size" [linkColor]="color">
  </maced-link>
  <p>Use Case 8 : Link with queryParams</p>
  <maced-link id="linkId8" [links]="link6" [showNextIconClass]="true" [linkSize]="size" [linkColor]="color">
  </maced-link>
</div>